export const tabNames = ['LATEST_PROMOTION', 'PAST_EVENTS']